import { CardSvg } from '@/play/cardSvg'

/** Home card art: 009's moon under a starry sky, with round shiny neon gobs (one with googly eyes) and long shadows. */
export function MoonSlime2CardArt() {
  const stars = [[24, 22], [62, 48], [98, 16], [140, 36], [176, 12], [214, 30], [252, 18], [292, 44], [120, 64], [44, 70], [270, 74], [196, 58]]
  return (
    <CardSvg bg="#070915">
      {stars.map(([x, y], i) => <circle key={i} cx={x} cy={y} r={i % 3 === 0 ? 1.8 : 1.1} fill="#f4f6ff" />)}
      <circle cx="262" cy="46" r="14" fill="#3f8cff" />
      <path d="M0 132 C 60 118, 120 124, 170 120 S 270 116, 320 126 V 200 H 0 Z" fill="#a9abb1" />
      <ellipse cx="238" cy="172" rx="26" ry="7" fill="#8c8e95" />
      {/* long shadows to the lower right (a low sun from the upper left) */}
      <ellipse cx="150" cy="160" rx="62" ry="10" fill="#5c5e66" />
      <ellipse cx="236" cy="142" rx="34" ry="7" fill="#5c5e66" />
      {/* a big green gob with eyes, a pink one fused to it, a small cyan one */}
      <path d="M58 156 C 58 112, 132 112, 132 156 Z" fill="#6dff3a" />
      <path d="M118 156 C 118 130, 164 130, 164 156 Z" fill="#ff3fb4" />
      <path d="M200 140 C 200 120, 232 120, 232 140 Z" fill="#2ef2ff" />
      <ellipse cx="74" cy="128" rx="4" ry="8" fill="#ffffff" opacity="0.7" transform="rotate(-30 74 128)" />
      <ellipse cx="128" cy="138" rx="3" ry="5" fill="#ffffff" opacity="0.6" transform="rotate(-30 128 138)" />
      <circle cx="84" cy="138" r="9" fill="#fbfbf6" />
      <circle cx="106" cy="138" r="9" fill="#fbfbf6" />
      <circle cx="87" cy="141" r="4.5" fill="#14141a" />
      <circle cx="109" cy="141" r="4.5" fill="#14141a" />
    </CardSvg>
  )
}
